"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TenantContext", {
    enumerable: true,
    get: function() {
        return TenantContext;
    }
});
const _common = require("@nestjs/common");
const TenantContext = (0, _common.createParamDecorator)((data, ctx)=>{
    const request = ctx.switchToHttp().getRequest();
    return request.context;
});
